document.addEventListener("DOMContentLoaded", () => {
  const API = "https://ecom-api.tvsmotor.com/tvs_warranty";
  // ===== DOM ELEMENTS =====
  const warrantyLoader = document.querySelector("#warranty-loader");
  const mobileForm = document.getElementById("mobile-form");
  const otpForm = document.getElementById("otp-form");
  const customerInfoSection = document.getElementById("customer-info-section");
  const uploadInvoiceSection = document.getElementById(
    "upload-invoice-section",
  );
  const verifyButton = document.querySelector(".verify-button");
  // Mobile form elements
  const warrantyFormEl = document.getElementById("warranty-form");
  const mobileInput = document.getElementById("mobile-number");
  const otpButton = warrantyFormEl?.querySelector('button[type="submit"]');
  // OTP form elements
  const otpVerificationForm = document.getElementById("otp-verification-form");
  const otpMobileDisplay = document.getElementById("otp-mobile-number");
  const otpInputs = document.querySelectorAll(".otp-input");
  const editMobileBtn = document.getElementById("edit-mobile");
  const resendOtpButton = document.getElementById("resend-otp");
  const verifyOtpButton = otpVerificationForm?.querySelector(
    'button[type="submit"]',
  );

  // Customer info form elements
  const customerInfoForm = document.getElementById("customer-info-form");
  const firstNameInput = document.getElementById("first-name");
  const mobileDisplayInput = document.getElementById("mobile");
  const emailInput = document.getElementById("email");
  const serialIdInput = document.getElementById("serial-id");
  const termsCheckbox = document.getElementById("terms-checkbox");
  const termsError = document.getElementById("terms-error");
  const customerInfoSubmitBtn = document.getElementById("customer-info-submit");
  const backToCustomerInfoBtn = document.getElementById(
    "back-to-customer-infobtnWarrenty",
  );
  const goToLoginBtn = document.getElementById("go-to-login-page");

  // Invoice form elements
  const uploadInvoiceForm = document.getElementById("upload-invoice-form");
  const invoiceDateInput = document.getElementById("invoice-date");
  const purchaseChannelInput = document.getElementById("purchase-channel");
  const invoiceFileInput = document.getElementById("invoice-file");
  const fileText = document.getElementById("file-text");
  const fileNameDisplay = document.getElementById("file-name-display");
  const fileNameText = document.getElementById("file-name-text");
  const errorMessage = document.getElementById("error-message");
  const invoiceDetailsFields = document.getElementById(
    "invoice-details-fields",
  );
  const invoicePreview = document.getElementById("invoice-preview");
  const actionButtons = document.getElementById("action-buttons");
  const pdfFilename = document.getElementById("pdf-filename");
  const pdfFilesize = document.getElementById("pdf-filesize");
  const reuploadBtn = document.getElementById("reupload-btn");
  const activateWarrantyBtn = document.getElementById("activate-warranty-btn");
  const backToCustomerInfoBtnInvoice = document.getElementById(
    "back-to-customer-info",
  );

  let currentMobile = ""; // Simple variable — refresh pe khud clear ho jaayega
  const token = localStorage.getItem("token");
    const getToken = () => localStorage.getItem("token");


  // ── JOURNEY TRACKER ─────────────────────────────────────────────
    const TRACK_URL = `${API}/track-journey`;

    function getSid() {
      let sid = sessionStorage.getItem("_tvs_sid");
      if (!sid) {
        sid = crypto.randomUUID
          ? crypto.randomUUID()
          : Math.random().toString(36).slice(2) + Date.now().toString(36);
        sessionStorage.setItem("_tvs_sid", sid);
      }
      return sid;
    }

    function track(step, options = {}) {
      try {
        const payload = JSON.stringify({
          sessionId: getSid(),
          step,
          status:   options.status   || "success",
          mobile:   options.mobile   || sessionStorage.getItem("_tvs_mobile") || null,
          metadata: options.metadata || null,
        });
        if (navigator.sendBeacon) {
          navigator.sendBeacon(TRACK_URL, new Blob([payload], { type: "application/json" }));
        } else {
          fetch(TRACK_URL, { method: "POST", headers: { "Content-Type": "application/json" }, body: payload, keepalive: true });
        }
      } catch {}
    }
    // ────────────────────────────────────────────────────────────────

    track("page_landed");



  // ===== RESEND OTP TIMER =====
let resendTimerInterval = null;

function startResendTimer() {
  if (!resendOtpButton) return;

  let seconds = 120; // 2 minutes

  resendOtpButton.disabled = true;
  resendOtpButton.style.pointerEvents = "none";
  resendOtpButton.style.opacity = "0.5";
  resendOtpButton.textContent = `Resend OTP in 2:00`;

  clearInterval(resendTimerInterval);

  resendTimerInterval = setInterval(() => {
    seconds--;

    const mins = String(Math.floor(seconds / 60)).padStart(2, "0");
    const secs = String(seconds % 60).padStart(2, "0");
    resendOtpButton.textContent = `Resend OTP in ${mins}:${secs}`;

    if (seconds <= 0) {
      clearInterval(resendTimerInterval);
      resendOtpButton.disabled = false;
      resendOtpButton.style.pointerEvents = "auto";
      resendOtpButton.style.opacity = "1";
      resendOtpButton.textContent = "Resend OTP";
    }
  }, 1000);
}

  // ===== STATE MANAGEMENT =====
  const state = {
    customerPhone: cookieGet("customer_phone"),
    isOtpVerified: cookieGet("otp_verified") === "true",
    serialValidation: { valid: false, checked: false },
    selectedFile: null,
    pendingFormData: null,
  };

  // ===== TOASTR CONFIG =====
  toastr.options = {
    closeButton: true,
    progressBar: true,
    positionClass: "toast-top-right",
    timeOut: 4000,
    extendedTimeOut: 1000,
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    preventDuplicates: true,
    newestOnTop: true,
  };

  // ===== HELPERS: MOBILE FORMAT & LOADERS =====
  const formatMobile = (num) => num.replace(/\D/g, "").slice(-10);

  function showLoader() {
    if (warrantyLoader) {
      warrantyLoader.style.display = "flex";
      document.body.style.overflow = "hidden";
    }
  }

  function hideLoader() {
    if (warrantyLoader) {
      warrantyLoader.style.display = "none";
      document.body.style.overflow = "auto";
    }
  }

  // ===== HELPERS: COOKIES WITH 30-MIN EXPIRY =====
  function cookieSet(key, value, expiryMs = 30 * 60 * 1000) {
    const expires = new Date(Date.now() + expiryMs).toUTCString();
    document.cookie = `${encodeURIComponent(key)}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Strict`;
  }

  function cookieGet(key) {
    const encodedKey = encodeURIComponent(key);
    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
      const [rawKey, ...rawValueParts] = cookie.split("=");
      if (rawKey === encodedKey) {
        try {
          return decodeURIComponent(rawValueParts.join("="));
        } catch {
          return null;
        }
      }
    }
    return null;
  }

  function cookieClear(...keys) {
    keys.forEach((key) => {
      document.cookie = `${encodeURIComponent(key)}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict`;
    });
  }

  // ===== PAGE LOAD: RESTORE STATE =====
  function restoreState() {
    const savedMobile = cookieGet("customer_phone");
    const isVerified = cookieGet("otp_verified") === "true";

    // Hide login button initially (mobile and OTP steps)
    if (goToLoginBtn) {
      goToLoginBtn.style.display = "none";
    }

    if (savedMobile && isVerified) {
      // Both verified and mobile saved → show customer info
      mobileForm.classList.add("hidden");
      otpForm.classList.add("hidden");
      customerInfoSection.classList.remove("hidden");
      mobileDisplayInput.value = savedMobile;
      window.scrollTo({ top: 0, behavior: "smooth" });

      // Show login button when customer info is visible
      if (goToLoginBtn) {
        goToLoginBtn.style.display = "block";
      }
    } else if (savedMobile && !isVerified) {
      // Mobile saved but not verified → show OTP screen
      mobileForm.classList.add("hidden");
      otpForm.classList.remove("hidden");
      otpMobileDisplay.textContent = savedMobile;
      otpInputs[0]?.focus();

      // Initialize OTP button state
      checkOtpComplete();
    } else {
      // Nothing saved → show mobile form
      mobileForm.classList.remove("hidden");
      otpForm.classList.add("hidden");
      customerInfoSection.classList.add("hidden");
    }
  }

  // ===== STEP 1: SEND OTP =====
  if (warrantyFormEl) {
    warrantyFormEl.addEventListener("submit", async (e) => {
      e.preventDefault();

      const mobile = formatMobile(mobileInput.value);

      // Validate mobile format
      if (!/^[6-9]\d{9}$/.test(mobile)) {
        toastr.error("Enter valid mobile number");
        return;
      }

      // Disable button during API call
      otpButton.disabled = true;
      otpButton.textContent = "Sending...";
      showLoader();

      track("mobile_entered", { mobile });
      sessionStorage.setItem("_tvs_mobile", mobile);

      try {
        const res = await fetch(`${API}/send-otp`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "ngrok-skip-browser-warning": "true",
          },
          body: JSON.stringify({ mobile: "91" + mobile }),
        });

        const data = await res.json();

        if (data.success) {
          track("otp_sent", { mobile });
          // Switch UI: hide mobile form, show OTP form
          mobileForm.classList.add("hidden");
          otpForm.classList.remove("hidden");
          otpMobileDisplay.textContent = mobile;
          otpInputs[0]?.focus();
          currentMobile = mobile; // Variable mein store karo
          startResendTimer();
        } else {
          track("otp_failed", { status: "failed", mobile, metadata: { reason: data.message } });
          toastr.error(data.message || "Failed to send OTP");
        }
      } catch (err) {
        console.error("Send OTP error:", err);
        toastr.error("API error");
      } finally {
        hideLoader();
        otpButton.disabled = false;
        otpButton.textContent = "Send OTP";
      }
    });
  }

  // Function to check if all OTP fields are filled
  function checkOtpComplete() {
    const inputValues = [...otpInputs].map((i) => i.value);
    const otp = inputValues.join("");
    if (verifyOtpButton) {
      verifyOtpButton.disabled = otp.length !== 6;
    }
  }

  otpInputs.forEach((input, index) => {
    input.addEventListener("input", (e) => {
      // Only accept digits
      if (!/^\d$/.test(e.target.value)) {
        e.target.value = "";
        return;
      }

      // Auto-focus next input
      if (e.target.value && index < otpInputs.length - 1) {
        otpInputs[index + 1].focus();
      }

      // Check if OTP is complete after each input
      checkOtpComplete();
    });

    input.addEventListener("keydown", (e) => {
      // Backspace: go to previous input
      if (e.key === "Backspace" && !e.target.value && index > 0) {
        otpInputs[index - 1].focus();
      }

      // Check if OTP is complete after keydown (handles backspace and delete)
      checkOtpComplete();
    });

    input.addEventListener("paste", (e) => {
      e.preventDefault();
      const pasted = e.clipboardData
        .getData("text")
        .replace(/\D/g, "")
        .slice(0, 6);

      pasted.split("").forEach((digit, i) => {
        if (otpInputs[i]) otpInputs[i].value = digit;
      });

      if (otpInputs[otpInputs.length - 1]) {
        otpInputs[otpInputs.length - 1].focus();
      }

      // Check if OTP is complete after paste
      checkOtpComplete();
    });
  });

  // Initialize OTP button state
  checkOtpComplete();

  // ===== STEP 2B: EDIT MOBILE BUTTON =====
  if (editMobileBtn) {
    editMobileBtn.addEventListener("click", (e) => {
      e.preventDefault();
        clearInterval(resendTimerInterval); // ← ADD THIS LINE
         // Reset resend button
  if (resendOtpButton) {
    resendOtpButton.disabled = false;
    resendOtpButton.style.pointerEvents = "auto";
    resendOtpButton.style.opacity = "1";
    resendOtpButton.textContent = "Resend OTP";
  }


      // Clear cookies
      

      cookieClear("customer_phone", "otp_verified");

      // Clear OTP inputs
      otpInputs.forEach((i) => (i.value = ""));

      // Reset button state after clearing OTP
      checkOtpComplete();

      // Pre-fill mobile input
      const prevMobile = otpMobileDisplay.textContent.trim();
      if (prevMobile) mobileInput.value = prevMobile;

      // Re-enable send OTP button
      if (otpButton) otpButton.disabled = false;

      // Switch UI: hide OTP form, show mobile form
      otpForm.classList.add("hidden");
      mobileForm.classList.remove("hidden");

      // Focus mobile input
      mobileInput.focus();
    });
  }

  // ===== STEP 2C: RESEND OTP =====
  if (resendOtpButton) {
    resendOtpButton.addEventListener("click", async (e) => {
      e.preventDefault();

      let mobile = currentMobile || otpMobileDisplay.textContent.trim();

      if (!mobile) {
        toastr.error("Mobile missing");
        return;
      }

      mobile = formatMobile(mobile);

      showLoader();

      try {
        const res = await fetch(`${API}/resend-otp`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "ngrok-skip-browser-warning": "true",
          },
          body: JSON.stringify({ mobile: "91" + mobile }),
        });

        const data = await res.json();

        if (data.success) {
          otpInputs.forEach((i) => (i.value = ""));
          otpInputs[0]?.focus();
          // Reset button state after clearing OTP
          checkOtpComplete();
          startResendTimer();
        } else {
          toastr.error(data.message || "Failed to resend OTP");
        }
      } catch (err) {
        console.error("Resend OTP error:", err);
        toastr.error("Error resending OTP");
      } finally {
        hideLoader();
      }
    });
  }

  // ===== STEP 2D: VERIFY OTP =====
  if (otpVerificationForm) {
    otpVerificationForm.addEventListener("submit", async (e) => {
      e.preventDefault();

      const otp = [...otpInputs].map((i) => i.value).join("");
      let mobile = currentMobile || otpMobileDisplay.textContent.trim();

      // Validate OTP
      if (!/^\d{6}$/.test(otp)) {
        toastr.error("Enter valid 6 digit OTP");
        return;
      }

      if (!mobile) {
        toastr.error("Mobile missing");
        return;
      }

      mobile = formatMobile(mobile);

      // Check if OTP terms checkbox is accepted
      const otpTermsCheckboxForVerify =
        document.getElementById("otp-terms-checkbox");
      const otpTermsErrorForVerify = document.getElementById("otp-terms-error");

      if (!otpTermsCheckboxForVerify || !otpTermsCheckboxForVerify.checked) {
        if (otpTermsErrorForVerify) {
          otpTermsErrorForVerify.textContent =
            "Accept the Terms & Conditions to continue";
          otpTermsErrorForVerify.style.display = "block";
        }
        return;
      }

      // Hide error if checkbox is checked
      if (otpTermsErrorForVerify) {
        otpTermsErrorForVerify.style.display = "none";
      }

      // Disable button during API call
      verifyOtpButton.disabled = true;
      verifyOtpButton.textContent = "Verifying...";
      showLoader();

      try {
        const res = await fetch(`${API}/verify-otp`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "ngrok-skip-browser-warning": "true",
          },
          body: JSON.stringify({ mobile: "91" + mobile, otp }),
        });

        const data = await res.json();

        if (data.success) {
          track("otp_verified", { mobile });
          // Save verified state to cookies
          cookieSet("otp_verified", "true");
          cookieSet("customer_phone", mobile);
           if (data.token) {
           localStorage.setItem("token", data.token);
           
           }
           
          // Check if warranty already registered for this mobile
          try {
            const checkRes = await fetch(`${API}/warranty/mobile/${mobile}`, {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                "ngrok-skip-browser-warning": "true",
                 Authorization: `Bearer ${getToken()}`,   
              },
            });

            const checkData = await checkRes.json();

            if (
              checkData.success &&
              checkData.data &&
              checkData.data.length > 0
            ) {

              track("dashboard_viewed", { mobile });
              // Already registered → redirect to manage-protection
              window.location.href = "/pages/manage-protection";
              return;
            }
          } catch (checkErr) {
            console.warn(
              "Warranty check failed, proceeding to registration:",
              checkErr,
            );
          }

          // Not yet registered → show customer info form
          mobileForm.classList.add("hidden");
          otpForm.classList.add("hidden");
          customerInfoSection.classList.remove("hidden");
          backToCustomerInfoBtn.style.display = "none";
          window.scrollTo(0, 0);

          // Show login button when customer info is visible
          if (goToLoginBtn) {
            goToLoginBtn.style.display = "block";
          }

          // Pre-fill mobile
          mobileDisplayInput.value = mobile;

          window.scrollTo(0, 0);
        } else {
          track("otp_wrong", { status: "failed", mobile });
          toastr.error(data.message || "Invalid OTP");
          otpInputs.forEach((i) => (i.value = ""));
          otpInputs[0].focus();
        }
      } catch (err) {
        console.error("Verify OTP error:", err);
        toastr.error("Verification failed");
      } finally {
        hideLoader();
        verifyOtpButton.disabled = false;
        verifyOtpButton.textContent = "Verify OTP";
      }
    });
  }

  // ===== STEP 3A: SERIAL ID REAL-TIME VALIDATION =====
  let serialDebounceTimer = null;

  function showSerialFeedback(msg, isError) {
    let el = document.getElementById("serial-id-feedback");
    if (!el) {
      el = document.createElement("p");
      el.id = "serial-id-feedback";
      el.style.cssText = "font-size:12px;margin-bottom:0;margin-top:3px;";
      serialIdInput?.parentNode?.appendChild(el);
    }
    el.style.color = isError ? "#e53e3e" : "#38a169";
    el.textContent = msg;
    el.style.display = "block";
    if (serialIdInput) {
      serialIdInput.style.borderColor = isError ? "#e53e3e" : "#38a169";
    }
  }

  function clearSerialFeedback() {
    const el = document.getElementById("serial-id-feedback");
    if (el) el.style.display = "none";
    if (serialIdInput) serialIdInput.style.borderColor = "";
  }

  async function validateSerialId(serial) {
    if (!serial) {
      clearSerialFeedback();
      state.serialValidation.valid = false;
      state.serialValidation.checked = false;
      return;
    }

    showSerialFeedback("Checking serial ID…", false);
    state.serialValidation.valid = false;
    state.serialValidation.checked = false;

    try {
      // Step 1: Check if serial exists
      const checkRes = await fetch(
        `${API}/check-serial?serial=${encodeURIComponent(serial)}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "ngrok-skip-browser-warning": "true",
             Authorization: `Bearer ${getToken()}`,   // 👈 ADD THIS

          },
        },
      );
      const checkData = await checkRes.json();

      if (!checkData.success) {
        track("serial_invalid", { status: "failed", metadata: { serial } });
        showSerialFeedback(
          checkData.message ||
            "Serial ID not found. Please check and try again.",
          true,
        );
        state.serialValidation.valid = false;
        state.serialValidation.checked = true;
        return;
      }

      // Step 2: Check warranty claim status
      try {
        const warrantyRes = await fetch(
          `${API}/warranty/${encodeURIComponent(serial)}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "ngrok-skip-browser-warning": "true",
                Authorization: `Bearer ${getToken()}`,       
            },
            signal: AbortSignal.timeout(5000),
          },
        );

        if (
          warrantyRes.ok &&
          warrantyRes.headers.get("content-type")?.includes("application/json")
        ) {
          const warrantyData = await warrantyRes.json();
          const status = warrantyData?.data?.warrantyStatus;

          if (status === "1") {
            showSerialFeedback(
              "This serial ID has already been claimed.",
              true,
            );
            state.serialValidation.valid = false;
            state.serialValidation.checked = true;
            return;
          }
        }
      } catch (warrantyErr) {
        console.warn(
          "Warranty status check failed, proceeding:",
          warrantyErr.message,
        );
      }

      // All checks passed
      showSerialFeedback("Serial ID verified ✓", false);
      state.serialValidation.valid = true;
      state.serialValidation.checked = true;
    } catch (err) {
      console.error("Serial validation error:", err);
      showSerialFeedback(
        "Could not validate serial ID. Please try again.",
        true,
      );
      state.serialValidation.valid = false;
      state.serialValidation.checked = false;
    }
  }

  if (serialIdInput) {
    serialIdInput.addEventListener("input", () => {
      clearTimeout(serialDebounceTimer);
      const val = serialIdInput.value.trim();
      if (!val) {
        clearSerialFeedback();
        state.serialValidation.valid = false;
        state.serialValidation.checked = false;
        return;
      }
      serialDebounceTimer = setTimeout(() => validateSerialId(val), 600);
    });

    serialIdInput.addEventListener("blur", () => {
      clearTimeout(serialDebounceTimer);
      const val = serialIdInput.value.trim();
      if (val && !state.serialValidation.checked) validateSerialId(val);
    });
  }

  // ===== STEP 3B: TERMS CHECKBOX AUTO-HIDE ERROR =====
  if (termsCheckbox) {
    termsCheckbox.addEventListener("change", function () {
      if (this.checked) {
        termsError.style.display = "none";
      }
    });
  }

  // ===== STEP 3C: OTP TERMS CHECKBOX AUTO-HIDE ERROR =====
  const otpTermsCheckbox = document.getElementById("otp-terms-checkbox");
  const otpTermsError = document.getElementById("otp-terms-error");

  if (otpTermsCheckbox && otpTermsError) {
    otpTermsCheckbox.addEventListener("change", function () {
      if (this.checked) {
        otpTermsError.style.display = "none";
      }
    });
  }

  // ===== STEP 3C: CUSTOMER INFO FORM SUBMISSION =====
  if (customerInfoForm) {
    customerInfoForm.addEventListener("submit", async (e) => {
      e.preventDefault();

      const firstName = firstNameInput.value.trim();
      const email = emailInput.value.trim();
      const mobile = mobileDisplayInput.value.trim();
      const serialId = serialIdInput.value.trim();
      const termsAccepted = termsCheckbox.checked;

      // Validate all fields filled
      if (!firstName || !email || !mobile || !serialId) {
        termsError.textContent = "Please fill all required fields";
        termsError.style.display = "block";
        return;
      }

      // Validate terms checkbox
      if (!termsAccepted) {
        termsError.textContent = "Please accept terms and conditions";
        termsError.style.display = "block";
        return;
      }

      if (state.serialValidation.checked && !state.serialValidation.valid) {
        termsError.textContent =
          "Please enter a valid Serial ID before proceeding";
        termsError.style.display = "block";
        serialIdInput?.focus();

        setTimeout(() => {
          termsError.style.display = "none";
          termsError.textContent = "";
        }, 5000); // 5 sec

        return;
      }

      // Disable submit button during API call
      customerInfoSubmitBtn.disabled = true;
      customerInfoSubmitBtn.textContent = "Validating...";
      showLoader();

      try {
        // Re-validate serial as safety-net
        const checkRes = await fetch(
          `${API}/check-serial?serial=${encodeURIComponent(serialId)}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "ngrok-skip-browser-warning": "true",
               Authorization: `Bearer ${getToken()}`,

            },
          },
        );

        const checkData = await checkRes.json();

        if (!checkData.success) {
          showSerialFeedback(checkData.message || "Serial ID not found.", true);
          toastr.error(checkData.message || "Invalid Serial Number");
          state.serialValidation.valid = false;
          state.serialValidation.checked = true;
          return;
        }

        // All validations passed → save customerData to sessionStorage
        const customerData = {
          first_name: firstName,
          name: firstName,
          email,
          mobile,
          serial_id: serialId,
          terms_accepted: termsAccepted,
          agreedToTerms: termsAccepted,
        };

        sessionStorage.setItem("customerData", JSON.stringify(customerData));

        track("customer_info_submitted", { metadata: { serialId } }); 

        // Hide customer info form, show invoice section
        customerInfoSection.classList.add("hidden");
        uploadInvoiceSection.style.display = "block";
        window.scrollTo({ top: 0, behavior: "smooth" });
      } catch (err) {
        console.error("Customer info submission error:", err);
        toastr.error("Validation failed");
      } finally {
        hideLoader();
        customerInfoSubmitBtn.disabled = false;
        customerInfoSubmitBtn.textContent = "Next";
      }
    });
  }

  // ===== STEP 3D: BACK BUTTON IN CUSTOMER INFO =====
  if (backToCustomerInfoBtn) {
    backToCustomerInfoBtn.addEventListener("click", () => {
      window.location.href = "/pages/manage-protection";
    });
  }

  // ===== STEP 3E: GO TO LOGIN BUTTON =====
  if (goToLoginBtn) {
    goToLoginBtn.addEventListener("click", () => {
      cookieClear("customer_phone", "otp_verified");
      sessionStorage.clear();
      window.location.href = "/pages/warranty-registration";
    });
  }

  // ===== STEP 4D: BACK BUTTON IN INVOICE SECTION =====
  if (backToCustomerInfoBtnInvoice) {
    backToCustomerInfoBtnInvoice.addEventListener("click", () => {
      uploadInvoiceSection.style.display = "none";
      customerInfoSection.classList.remove("hidden");
      window.scrollTo({ top: 0, behavior: "smooth" });

      // Show login button when customer info is visible
      if (goToLoginBtn) {
        goToLoginBtn.style.display = "block";
      }

      // Restore from sessionStorage
      const savedData = sessionStorage.getItem("customerData");
      if (savedData) {
        try {
          const data = JSON.parse(savedData);
          if (firstNameInput) firstNameInput.value = data.first_name || "";
          if (emailInput) emailInput.value = data.email || "";
          if (serialIdInput) serialIdInput.value = data.serial_id || "";
        } catch (e) {
          console.error("Error restoring form data:", e);
        }
      }
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  restoreState();

  // Hide loader when page is fully ready
  if (warrantyLoader) {
    warrantyLoader.style.display = "none";
  }
});